<h5 mat-dialog-title class="modal-dialog m-0">
  {{ title() }}
  <dialog-close-button [closeWithoutConfirm]="true"></dialog-close-button>
</h5>
<mat-dialog-content class="p-4">
  <p [innerHTML]="message()"></p>
</mat-dialog-content>
<mat-dialog-actions class="p-4">
  <button
    mat-flat-button
    color="primary"
    type="button"
    class="action-button-primary"
    data-testId="info-popup-ok-button"
    cdkFocusInitial
    mat-dialog-close
  >
    OK
  </button>
</mat-dialog-actions>
